"use client";

import { useEffect, useState } from "react";

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

type Breakpoint = keyof typeof breakpoints;

export function useBreakpoint(): Breakpoint | null {
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null);

  useEffect(() => {
    const calcBreakpoint = () => {
      const width = window.innerWidth;

      if (width >= breakpoints["2xl"]) return "2xl";
      if (width >= breakpoints.xl) return "xl";
      if (width >= breakpoints.lg) return "lg";
      if (width >= breakpoints.md) return "md";
      if (width >= breakpoints.sm) return "sm";

      return null;
    };

    const handleResize = () => {
      setBreakpoint(calcBreakpoint());
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return breakpoint;
}
